import React, { Component } from "react";

import ReactMarkdown from 'react-markdown'
import rehypeRaw from 'rehype-raw'

import "./style.scss";
import colors from "@learningblocks/protocol-constants/lib/Styles/_colors.scss";

// Icons
import IconStart from "@learningblocks/protocol-constants/lib/Icons/start-solid";
import ProtocolOverviewIcon from "./img/ProtocolOverview-icon.svg";

export class ProtocolOverview extends Component {
  start = () => {
    this.props.showModal(false);
  };

  // this is skip the 'start simulation' click step while working on the protocol section, should be removed
  componentWillMount(){
    //this.start();
    // undo above// comment it
  }
  // remove above 

  render() {
    return (
      <div className="modal-section level-choice">
        <img src={ProtocolOverviewIcon} style={{height: "130px"}} alt="Protocol Overview icon" />
        <div className="modal-header">
          <h2 tabIndex={0}>Read through the protocol</h2>
        </div>
        <ol style={{ padding: "0 0 0 16px" }}>
          {this.props.sequence.map((step) => {
            return (
              <li style={{ marginBottom: "16px" }} tabIndex={0}>
                <ReactMarkdown rehypePlugins={[rehypeRaw]} components={{p: 'span'}}>{step.label.replace("\\_", "_")}</ReactMarkdown>
              </li>
            );
          })}
        </ol>
        <div className="modal-footer lvl-choice">
          <button
            aria-label="Start simulation button"
            className="modal-btn-primary lvl-choice"
            onClick={this.start}
          >
            <IconStart
              style={{ color: colors.charcoal1, height: "16px", top: "2px" }}
            />
            Start simulation
          </button>
        </div>
      </div>
    );
  }
}
